import useSWR from 'swr';
import type { AxiosError } from 'axios';
import axios from 'axios';
import type ILabelEnumPair from '../../components/global/GlobalInterfaces';

const GetFacilities = () :
{ employeeLevels: ILabelEnumPair[] | undefined,
  isLoading: boolean,
  isError: boolean, } => {
  const fetcher = (url: string) => axios.get<ILabelEnumPair[]>(url)
    .then((response) => response.data);

  const { data, error } = useSWR<ILabelEnumPair[], AxiosError>('/employeeInfo/getEmployeeRoles',
    (url) => fetcher(url));

  return {
    employeeLevels: data,
    isLoading: !error && !data,
    isError: Boolean(error),
  };
};

export default GetFacilities;
